import { FadeContainer, FadeText } from 'components/CustomAnimations';
import { FormContent } from 'screens/Forms/FormContent';

export const ContactSection = () => {
  return (
    <div className="contact-section-container">
      <FadeContainer className="contact-section-title" inViewTrigger>
        <FadeText progressive className="h2-dtm" text="Contact Us" />
        <FadeText
          className="h4-text"
          text="Please fill out the form and someone from our team will be in touch shortly."
        />
      </FadeContainer>
      <div className="contact-section-hubspot-form">
        <FormContent form="contact-us" />
      </div>
    </div>
  );
};
